<div [class]="{'protected': !controlService.locked()}" [style.margin-top.px]="20">
  <button (click)="unLockAdvice()" matButton="filled">Skrivskyddad rådgivning</button>
</div>


<mat-stepper #thaStepper [linear]="testService.linear" class="stepper"
             labelPosition="bottom">
  <mat-step [completed]="steps[1]()">
    <ng-template matStepLabel>Låntagare</ng-template>
    <ng-template matStepContent>
      <div [class]="{'disable-click-events': controlService.locked()}"
           [attr.inert]="controlService.locked() ? '' : null"
           class="margin-top-small">
        <h2>Rådgivning</h2>
        <spb-scenario/>

        <spb-general (stepValid)="stepValid($event, 1)"/>
        <div class="button-space">
        </div>
      </div>
      <div>
        <button [disabled]="!steps[1]()" matButton="filled"
                matStepperNext>Nästa
        </button>
      </div>

    </ng-template>
  </mat-step>
  <mat-step [completed]="steps[2]()">
    <ng-template matStepLabel>Inkomster / Kostnader</ng-template>

    <div [class]="{'disable-click-events': controlService.locked()}"
         [attr.inert]="controlService.locked() ? '' : null"
         class="margin-top-small">
      <h2>Inkomster / Kostnader</h2>
      <spb-kalp (stepValid)="stepValid($event, 2)"/>
    </div>

    <div class="button-space">
      <div>
        <button matButton="outlined" matStepperPrevious>Tillbaka
        </button>
      </div>
      <div>
        <button [disabled]="!steps[2]()" matButton="filled"
                matStepperNext>Nästa
        </button>
      </div>
    </div>
  </mat-step>
  <mat-step [completed]="steps[3]()">
    <ng-template matStepLabel>Boende</ng-template>
    <div [class]="{'disable-click-events': controlService.locked()}"
         [attr.inert]="controlService.locked() ? '' : null"
         class="margin-top-small">
      <h2>Boende</h2>
      <spb-living (stepValid)="stepValid($event, 3)"/>
    </div>
    <div class="button-space">
      <div>
        <button matButton="outlined" matStepperPrevious>Tillbaka
        </button>
      </div>
      <div>
        <button [disabled]="!steps[3]()" matButton="filled"
                matStepperNext>Nästa
        </button>
      </div>
    </div>
  </mat-step>
  <mat-step completed>
    <ng-template matStepLabel>Befintliga lån</ng-template>
    <div [class]="{'disable-click-events': controlService.locked()}"
         [attr.inert]="controlService.locked() ? '' : null"
         class="margin-top-small">
      <spb-existing-loan/>
    </div>
    <div class="button-space">
      <div>
        <button matButton="outlined" matStepperPrevious>Tillbaka
        </button>
      </div>
      <div>
        <button matButton="filled" matStepperNext>Nästa</button>
      </div>
    </div>
  </mat-step>
  <mat-step [completed]="steps[5]()">
    <ng-template matStepLabel>Hur tänker {{ plrDuNi.toLowerCase() }}
      kring {{ plrDittErt.toLowerCase() }} boende
    </ng-template>
    <div [class]="{'disable-click-events': controlService.locked()}"
         [attr.inert]="controlService.locked() ? '' : null"
         class="margin-top-small">
      <spb-questions (stepValid)="stepValid($event, 5)"/>
    </div>
    <div class="button-space">
      <div>
        <button matButton="outlined" matStepperPrevious>Tillbaka
        </button>
      </div>
      <div>
        <button [disabled]="!steps[5]()" matButton="filled"
                matStepperNext>Nästa
        </button>
      </div>
    </div>
  </mat-step>
  <mat-step completed>
    <ng-template matStepLabel>KALP</ng-template>
    <ng-template matStepContent>
      <div class="legend margin-top-small">
        <spb-chart-legend/>
      </div>
      <spb-piechart/>
      @if (kalpService.kalpResult$ | async) {
        <spb-kalp-result/>
      }
      <div class="button-space">
        <div>
          <button matButton="outlined" matStepperPrevious>
            Tillbaka
          </button>
        </div>
        <div>
          <button matButton="filled" matStepperNext>Nästa
          </button>
        </div>
      </div>
    </ng-template>
  </mat-step>
  <mat-step [completed]="steps[7]()">
    <ng-template matStepLabel>Förslag</ng-template>
    <div class="margin-top-small">
      <spb-proposal (stepValid)="stepValid($event, 7)"/>
    </div>
    <div class="button-space">
      <button matButton="outlined" matStepperPrevious>Tillbaka
      </button>
      <button [disabled]="!steps[7]()" matButton="filled"
              matStepperNext>Nästa
      </button>
    </div>
  </mat-step>
  <mat-step>
    <ng-template matStepLabel>Sammanställning</ng-template>
    <div class="margin-top-small">
      <spb-summary/>
    </div>
    <div class="button-space">
      @if (hasDeclined()) {
        <button (click)="decline()" matButton="outlined">Kund avböjer inte
        </button>
      }
      <button matButton="outlined" matStepperPrevious>Tillbaka
      </button>
    </div>
  </mat-step>
</mat-stepper>
